import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatHorizontalStepper } from '@angular/material';
import { StepperServiceVM } from 'src/app/view-model/services/stepper-vm.service';
import { PasoDosComponent } from './paso-dos/paso-dos.component';
import { PasoUnoComponent } from './paso-uno/paso-uno.component';

@Component({
  selector: 'app-steppers',
  templateUrl: './steppers.component.html',
  styleUrls: ['./steppers.component.scss']
})
export class SteppersComponent implements AfterViewInit {

  @ViewChild('stepper', { static: false }) stepper: MatHorizontalStepper;

  @ViewChild(PasoDosComponent, { static: false }) pasoDos: PasoDosComponent;
  @ViewChild(PasoUnoComponent, { static: false }) pasoUno: PasoUnoComponent;
  init = false;

  constructor(private stepperService: StepperServiceVM) { }

  ngAfterViewInit() {
    this.stepperService.configure(this.stepper);
    // this.pasoUno.init();
  }

  next(): void {
    this.stepperService.nextStep();
  }

  get currentStep(): number {
    return this.stepperService.currentStep;
  }
}
